module.exports = __webpack_public_path__ + "assets/to-icon.7ad0b6bc.svg";